import { cx } from "@jugl-web/utils";
import { ButtonHTMLAttributes, ReactNode, forwardRef } from "react";

type ChatControlButtonSize = "md" | "lg";

interface ChatControlButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> {
  children: ReactNode;
  size?: ChatControlButtonSize;
  isActive?: boolean;
}

const classesBySize: Record<ChatControlButtonSize, string> = {
  md: "h-8 w-8",
  lg: "h-10 w-10",
};

export const ChatControlButton = forwardRef<
  HTMLButtonElement,
  ChatControlButtonProps
>(
  (
    { children, size = "md", isActive = false, className, onClick, ...props },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type="button"
        className={cx(
          "active:bg-grey-200 flex shrink-0 cursor-pointer items-center justify-center rounded-lg border-0 bg-transparent transition-colors",
          isActive ? "bg-grey-100" : "hover:bg-grey-100",
          classesBySize[size],
          className
        )}
        onClick={onClick}
        {...props}
      >
        {children}
      </button>
    );
  }
);
